import React, { useEffect } from "react";
import { company } from "../mock/mock";

const Privacy = () => {
  useEffect(() => {
    document.title = "Privacy Policy | Morrisville Communications";
  }, []);

  return (
    <div className="bg-white">
      <section className="brand-gradient text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h1 className="text-4xl font-extrabold">Privacy Policy</h1>
          <p className="mt-3 text-blue-100">Last updated: 2026</p>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate max-w-none space-y-6 text-slate-600">
          <p>
            {company.legalName} ("we", "us", or "our") respects your privacy and is committed to protecting your personal information. This policy explains how we collect, use, and safeguard your data when you use our website and services.
          </p>
          <h2 className="text-2xl font-bold text-slate-900">Information we collect</h2>
          <p>
            We collect information you provide directly - such as your name, email, phone number and company - when you request a consultation or contact us. We also use cookies to analyze website traffic and optimize your experience.
          </p>
          <h2 className="text-2xl font-bold text-slate-900">How we use your information</h2>
          <p>
            We use your information to respond to your inquiries, arrange demos and pricing from our partners, and improve our services. <strong>We will never share your contact information with any of our partners prior to your verbal or written consent.</strong>
          </p>
          <h2 className="text-2xl font-bold text-slate-900">SMS communications</h2>
          <p>
            By opting in, you agree to receive SMS messages from {company.legalName}. Message and data rates may apply. You can opt out at any time by replying STOP.
          </p>
          <h2 className="text-2xl font-bold text-slate-900">Cookies</h2>
          <p>
            We use cookies to analyze website traffic and optimize your website experience. By accepting our use of cookies, your data will be aggregated with all other user data.
          </p>
          <h2 className="text-2xl font-bold text-slate-900">Contact us</h2>
          <p>
            If you have any questions about this Privacy Policy, contact us at{" "}
            <a className="text-blue-700 font-medium" href={`mailto:${company.email}`}>{company.email}</a> or{" "}
            <a className="text-blue-700 font-medium" href={`tel:${company.phoneTel}`}>{company.phone}</a>.
          </p>
          <p>{company.address}</p>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
